import Dropdown from 'bootstrap/js/dist/dropdown';

(function ($, Drupal, once) {
  Drupal.behaviors.pagulasabiMainMenuDropdowns = {
    attach: function (context, settings) {
      once('pagulasabiMainMenuDropdownsJS', '.pagulasabi-menu .level.item-link', context).forEach(function (el) {
        // console.log('pagulasabiMainMenuDropdownsJS');
        var wrapper = $(el);
        if (wrapper.children('.dropdown-toggle').length == 0) {
          return;
        }

        // console.log('mouseenter ' + $wrapper[0].firstElementChild.id);
        var btn = wrapper.children('.dropdown-toggle').get(0);
        var dropdown = new Dropdown(btn);
        btn.addEventListener('shown.bs.dropdown', event => {
          // console.log('shown.bs.dropdown');
        })

        btn.addEventListener('show.bs.dropdown', function (e) {
          // console.log('show');
        });

        btn.addEventListener('hide.bs.dropdown', function (e) {
          // console.log('hide');
        });

        var hoverHandler = function (e) {

          // hide all
          var others = $('.pagulasabi-menu .level.item-link .dropdown-toggle.show');
          if (others.length > 0) {
            for (var cnt = 0; cnt < others.length; cnt++) {
              var d = new Dropdown(others[cnt]);
              d.hide();
            }
          }

          if (wrapper.children('.dropdown-menu').length > 0) {
            dropdown.show();

            var container = $(this).closest('.page .navbar .container-fluid');
            var dropdown_width = container.width();
            var dropdown_pos = container.children().first().offset().left;

            //FIXME: uncomment
            if ($('.gin--vertical-toolbar').length == 0 && $('.gin--horizontal-toolbar').length == 0) {
              // var dropdown_menu = wrapper.children('.dropdown-menu');
              // $(dropdown_menu).css('width', dropdown_width + 'px');
              // $(dropdown_menu).css('left', dropdown_pos + 'px');
            }
          }
        };

        var clickHandler = function (e) {
          // console.log('clickHandler ' + e.isDefaultPrevented() + " " + e.type);
          // this.children[1].click();
          location.href = this.children[1].href;
        };

        // .btn or button
        wrapper.children('.dropdown-toggle').on('mouseenter', hoverHandler);
        wrapper.children('.dropdown-toggle').on('click', clickHandler);
      });

      once('pagulasabiCollapseJS', '#menu-group', context).forEach(function () {
        // console.log('menu-pagulasabiCollapseJS');
        var $all = $(this).children();
        $all.each(function (index) {
          $(this).addClass('item-show');
        });

        $('#menu-group .accordion-collapse.js').each(function (index) {
          this.addEventListener('show.bs.collapse', function (e) {
            if ($(this).is(e.target)) {
              // console.log('1 ' + this.className);
              var item = $(this).closest('.item-link');
              $(item).addClass('item-show');
              $(item).removeClass('item-hide');
              $(item).addClass('item-active');

              $all.each(function (index) {
                if (!$(this).is($(item))) {
                  $(this).removeClass('item-show');
                  $(this).addClass('item-hide');
                }
              });
            }
          });
          this.addEventListener('hide.bs.collapse', function (e) {
            if ($(this).is(e.target)) {
              // console.log('2 ' + this.className);
              $(this).closest('.item-link').removeClass('item-active');
              $all.each(function (index) {
                $(this).removeClass('item-hide');
                $(this).addClass('item-show');
              });
            }
          });
        });
      });

      once('menuCountriesFilterJS', '.menu_countries_filter', context).forEach(function () {
        // console.log('menuCountriesFilterJS');
        var country_tid = $('.menu_countries_filter [name=country_tid]:checked').val();
        var item_id = $('.menu_countries_filter [name=country_tid]:checked').first().siblings().children('img').attr('alt');
        // console.log('country_tid ' + country_tid);
        // console.log('item_id ' + item_id);
        $(this).closest('.dropdown-support').attr('country_tid', country_tid);
        $(this).closest('.dropdown-support').attr('item_id', item_id);
      });
    }
  }
})(jQuery, Drupal, once);
